import { MovementDataStore } from '@skinsoft/entity';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { EntityFeaturedList } from '@skinsoft/ui';
import { Component } from 'vue-property-decorator';

import { toFeatured$ } from '../../serializer/featured';

@Component({
    components: {
        sEntityFeaturedList: EntityFeaturedList,
    },
    props: ['targetRouteName'],
    template: require('./movement-featured-list.html'),
})
export class MovementFeaturedList extends ReactiveVue {
    public $movementDataStore: MovementDataStore;
    public featuredStates = MovementDataStore.featuredStates;
    public sortFields = MovementDataStore.sortFields;
    public serializer = toFeatured$;
    public targetRouteName;
}
